import { Section } from "../components/Section";
import { TubeDetailForm } from "../components/tubes/TubeDetailForm";

export function NewTubePage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New container</Section.Title>
      <TubeDetailForm />
    </div>
  );
}
